export default __webpack_public_path__ + "static/media/value-impact.99f39587.svg";